import { DropTargetMonitor } from "react-dnd";
import { XYCoord } from "dnd-core";

export type DragItem = {
  index: number;
  id: string;
};

export type DraggableInstance = {
  getNode(): HTMLDivElement | null;
};

export const shouldMove = (
  hoverIndex: number,
  element: HTMLDivElement | null,
  dragIndex: number,
  monitor: DropTargetMonitor
) => {
  if (!element) {
    return false;
  }

  // Don't replace items with themselves
  if (dragIndex === hoverIndex) {
    return false;
  }

  // Determine rectangle on screen
  const hoverBoundingRect = element.getBoundingClientRect();

  // Get vertical middle
  const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

  // Determine mouse position
  const clientOffset = monitor.getClientOffset();

  // Get pixels to the top
  const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

  // Only perform the move when the mouse has crossed half of the items height
  // When dragging downwards, only move when the cursor is below 50%
  // When dragging upwards, only move when the cursor is above 50%

  // Dragging downwards
  if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
    return false;
  }

  // Dragging upwards
  if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
    return false;
  }

  return true;
};
